import LegalPageLayout from '../components/LegalPageLayout';

const PrivacyPolicyPage = () => (
  <LegalPageLayout
    title="Privacy Policy"
    description="Privacy Policy for Delta Valley Health Club."
    effectiveDate="February 21, 2024"
  >
    <p className="dv-size-body">
      Welcome to Delta Valley Health Club (&quot;we,&quot; &quot;our,&quot; or &quot;us&quot;). We are
      committed to protecting your personal information and your right to privacy. This policy
      applies to users and visitors of deltavalleyhealthclub.com and explains how we collect, use,
      and secure personal data. Questions may be sent to <a href="mailto:info@deltavac.com">info@deltavac.com</a>.
    </p>

    <h2 className="dv-size-heading">1. What Information Do We Collect?</h2>
    <h3 className="dv-size-subheading">Personal Data</h3>
    <p className="dv-size-body">While using our website, we may ask you to provide personal data including, but not limited to:</p>
    <ul>
      <li className="dv-size-body">Name</li><li className="dv-size-body">Email address</li><li className="dv-size-body">Phone number</li><li className="dv-size-body">Date of birth</li>
      <li className="dv-size-body">Health-related information</li><li className="dv-size-body">Payment details for paid services</li>
    </ul>
    <h3 className="dv-size-subheading">Usage Data</h3>
    <p className="dv-size-body">We may collect information about how the website is accessed and used, including IP address, browser type and version, pages visited, date and time, and other diagnostic data.</p>

    <h2 className="dv-size-heading">2. How Do We Use Your Information?</h2>
    <ul>
      <li className="dv-size-body">To provide and maintain our website and services.</li>
      <li className="dv-size-body">To respond to inquiries and provide customer care.</li>
      <li className="dv-size-body">To notify you about changes to our website or services.</li>
      <li className="dv-size-body">To support interactive website features.</li>
      <li className="dv-size-body">To monitor usage and detect, prevent, and address technical issues.</li>
    </ul>

    <h2 className="dv-size-heading">3. How Do We Store and Protect Your Information?</h2>
    <p className="dv-size-body">We use security measures designed to maintain the safety of personal information. Sensitive information, including payment details, is transmitted using secure methods.</p>

    <h2 className="dv-size-heading">4. Do We Share Your Personal Data?</h2>
    <p className="dv-size-body">We do not sell or trade personal data. We may share information with trusted service providers that help operate our website, conduct our business, or serve our members, provided those parties agree to keep the information confidential.</p>

    <h2 className="dv-size-heading">5. Cookies and Tracking Technologies</h2>
    <p className="dv-size-body">We may use cookies and similar technologies to understand website activity and support website functionality. Cookies may contain an anonymous unique identifier.</p>

    <h2 className="dv-size-heading">6. Your Privacy Rights</h2>
    <p className="dv-size-body">Depending on applicable law, you may request to access, correct, update, delete, restrict, transfer, or object to the processing of your personal data, or withdraw consent. Contact <a href="mailto:info@deltavac.com">info@deltavac.com</a> to make a request.</p>

    <h2 className="dv-size-heading">7. Third-Party Links</h2>
    <p className="dv-size-body">Our website may link to third-party websites. Those sites maintain their own privacy practices, and Delta Valley Health Club is not responsible for their content or activities.</p>

    <h2 className="dv-size-heading">8. Changes to This Privacy Policy</h2>
    <p className="dv-size-body">We may update this policy from time to time. Changes will be posted on this page.</p>

    <h2 className="dv-size-heading">9. Contact Us</h2>
    <p className="dv-size-body">Delta Valley Health Club<br />120 Guthrie Ln.<br />Brentwood, CA 94513<br /><a href="mailto:info@deltavac.com">info@deltavac.com</a></p>
  </LegalPageLayout>
);

export default PrivacyPolicyPage;
